import { Editor, Path } from 'slate';
import type { EditorPlugin } from '../../types/aha-editor';
import ToolInsertDividerLine from './tools/ToolInsertDividerLine';
import MarkdownPlugin from '../MarkdownPlugin/MarkdownPlugin';
import { isDividerLineElement } from '../../types/guards';
import NodeUtils from '../../AhaEditorUtils/NodeUtils';

const DividerLineMarkdownPlugin: EditorPlugin = {
  name: 'Divider line Markdown plugin',
  dependencies: [MarkdownPlugin],
  markdown: [
    {
      type: 'element',
      regex: /(?:^|[^-])(---)$/,
      triggerCharacter: '-',
      convert: (editor: Editor) => {
        ToolInsertDividerLine.action({ editor });
      },
      revert: (editor: Editor) => {
        const { selection } = editor;
        if (!selection) return;

        const parentPath = Path.parent(selection.anchor.path);
        if (!parentPath) return;
        const dividerLineEntry = NodeUtils.previousSibling(editor, parentPath, {
          match: isDividerLineElement,
        });

        if (dividerLineEntry) {
          Editor.deleteBackward(editor);
        }
      },
      blockMustBeEmpty: true,
    },
  ],
};
export default DividerLineMarkdownPlugin;
